import { render, staticRenderFns } from "./ApplicationsCoursesPage.vue?vue&type=template&id=40be5272&scoped=true&"
import script from "./ApplicationsCoursesPage.vue?vue&type=script&lang=ts&"
export * from "./ApplicationsCoursesPage.vue?vue&type=script&lang=ts&"
import style0 from "./ApplicationsCoursesPage.vue?vue&type=style&index=0&id=40be5272&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40be5272",
  null
  
)

export default component.exports